// extracted by mini-css-extract-plugin
export default {"collection":"Collection_collection__pnFmS","trendingCont":"Collection_trendingCont__YgG00","cardsGrid":"Collection_cardsGrid__j1Pbd"};